import { Pagination, PerPageDropdown, Loader } from "_components";
import { Fragment } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { ListingTable } from "./ListingTable";
import { UserAppliedOfferStatus } from "_constants";
export const Listing = ({
  numberOfTotalPages,
  paginatedData,
  setCurrentPage,
  setPerPage,
  currentPage,
  perPage,
  loadingOffers,
  status,
}) => {
  let title = "My Advertisers";
  if (status === UserAppliedOfferStatus.PENDING) {
    title = "Pending Advertisers";
  } else if (status === UserAppliedOfferStatus.DECLINED) {
    title = "Declined Advertisers";
  }
  return (
    <Fragment>
      <Card>
        <CardHeader className="card-header border-0">
          <div className="d-flex align-items-center">
            <h5 className="card-title mb-0 flex-grow-1">{title}</h5>
          </div>
        </CardHeader>
        <CardBody>
          <div className="table-responsive table-card mb-4 table-transaction">
            {loadingOffers ? (
              <Loader />
            ) : (
              <ListingTable data={paginatedData} status={status} />
            )}
          </div>
          <div
            className="d-flex mt-2"
            style={{ justifyContent: "space-between" }}
          >
            <div>
              <PerPageDropdown
                onPerPageChange={(perPage) => {
                  setPerPage(perPage);
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="pagination-wrap hstack gap-2">
              {paginatedData?.length > 0 && (
                <Pagination
                  className="pagination"
                  currentPage={currentPage}
                  totalCount={numberOfTotalPages}
                  pageSize={perPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};
